import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Tooltip} from "antd"

class FileName extends Component {
    render() {
        const {filename, fileUrl} = this.props

        return (
            <td className="FileName">
                {filename}
                <Tooltip title="Xem file pdf">
                    <a target='_blank' href={fileUrl} rel='noopener noreferrer' type='application/pdf'>
                        <Icon type="eye" className='ml-2'/>
                    </a>
                </Tooltip>
            </td>
        )
    }
}

FileName.propTypes = {
    filename: PropTypes.string,
    fileUrl: PropTypes.string
}

export default FileName